import fetch from './fetch';

const querySearch = () => {
    return fetch.post('icon/query')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    querySearch
}

